<div class="d-flex flex-column">
  <div class="mb-3">
    @if (activeNotification) {
      <app-notification [notification]="activeNotification"></app-notification>
    }
  </div>
  @if (notifications.length > 1) {
    <div class="d-flex justify-content-between">
      <wdpr-button theme="secondary" (click)="previous()" [disabled]="idx === 0">Previous</wdpr-button>
      <wdpr-button theme="secondary" (click)="next()" [disabled]="idx === notifications.length - 1">Next</wdpr-button>
    </div>
  }
</div>
